import { UserManager } from 'oidc-client'
// documentation settings -> https://github.com/IdentityModel/oidc-client-js/wiki


const settings = ()=>{ 
    return {
        realm: 'your-realm',
        authority: process.env.REACT_APP_KEYCLOAK_AUTHORITY,
        client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
        redirect_uri: `${window.location.origin}/login-keycloak`,
        response_type: "code",
        scope: "openid profile email",
        client_secret: process.env.REACT_APP_KEYCLOAK_CLIENT_SECRET,
        post_logout_redirect_uri: `${window.location.origin}/account/logout`,
    }
}

let userManager = new UserManager(settings());

export const getUser = () => {    
    return userManager.getUser();
}

export const login = async ()=> {    
    await userManager.signinRedirect()
}

export const logout = async ()=> {
    return userManager.signoutPopup()
        .then(() => {  console.log('LOGOUT SUCCESS'); })
        .catch((error) => { setTimeout(() => { window.close() }, 2000); });
};
